import { DestroyRef, inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateHelper } from "../utils/translate-helper";
import { ShopService } from "../services/shop.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SessionStorageService } from "../services/session-storage.service";
import { TranslateService } from "@ngx-translate/core";
import { DialogService } from "../services/dialog.service";
import { ErrorService } from "../services/error.service";
import HwUtil from "../utils/hw-util";
import { Subscription } from "rxjs";
import { AppInitService } from "../services/app-init.service";

export class PageBase {
    protected t = inject(TranslateHelper)
    protected translateService = inject(TranslateService);
    protected destroyRef = inject(DestroyRef);
    protected shopService = inject(ShopService);
    protected router = inject(Router);
    protected route = inject(ActivatedRoute);
    protected fb = inject(FormBuilder);
    protected errorService = inject(ErrorService);
    protected sessionStorageService = inject(SessionStorageService);
    protected dialogService = inject(DialogService);
    protected appInit = inject(AppInitService);

    serverErrors: Object;
    currLocale: string;
    progressVisible = false;

    constructor() {
        const sessionStorageUrlParams = this.sessionStorageService.getUrlParams();
        if (sessionStorageUrlParams)
            this.currLocale = sessionStorageUrlParams.Language;
    }

    // -- maxlength
    checkFormHasMaxLengthError(form: FormGroup, formFieldName: string): boolean {
        if (!this.checkFormFieldIsExists(form, formFieldName))
            return true;

        return form.controls[formFieldName].hasError('maxlength') && form.controls[formFieldName].touched;
    }

    getMaxLengthErrorMessage(formSettings: any, formFieldName: string): string {
        return this.replaceValueInText(this.t.errors("ERR_MAXLENGTH"), "{length}", formSettings[formFieldName].maxLength);
    }

    getMaxLength(formSettings: any, formFieldName: string): string {
        return formSettings[formFieldName].maxLength;
    }
    // -- maxlength

    // -- server error
    checkFormHasServerError(form: FormGroup, formFieldName: string): boolean {
        if (!this.checkFormFieldIsExists(form, formFieldName))
            return true;

        return form.controls[formFieldName].hasError('serverError');
    }

    getServerError(fieldName: string): string {
        if (!this.serverErrors)
            return "";

        return this.serverErrors[fieldName];
    }
    // -- server error

    replaceValueInText(replaceIn: string, replaceWhat: string, replaceTo: any): string {
        return replaceIn.replace(replaceWhat, replaceTo.toString());
    }

    // -- email error
    checkFormHasEmailError(form: FormGroup, formFieldName: string) {
        if (!this.checkFormFieldIsExists(form, formFieldName))
            return true;

        return form.controls[formFieldName].hasError('email') && form.controls[formFieldName].touched;
    }
    // -- email error

    checkFormHasPatternError(form: FormGroup, formFieldName: string): boolean {
        if (!this.checkFormFieldIsExists(form, formFieldName))
            return true;

        return form.controls[formFieldName].hasError('pattern') && form.controls[formFieldName].touched;
    }

    checkFormHasRequiredError(form: FormGroup, formFieldName: string): boolean {
        if (!this.checkFormFieldIsExists(form, formFieldName))
            return true;

        return form.controls[formFieldName].hasError('required') && form.controls[formFieldName].touched;
    }

    checkFormFieldIsExists(form: FormGroup, formFieldName: string): boolean {
        return form && form.controls && form.controls[formFieldName] != null;
    }

    clearControl(event: any, form: FormGroup, formField: string): void {
        if (this.checkFormFieldIsExists(form, formField)) {
            event.stopPropagation();
            form.controls[formField].setValue(null);
        }
    }

    getPaymentOptionIconUrlByType(type: string): string {
        return "../../../assets/icons/payment-options/" + type + ".jpg";
    }    

    backToDealerWebsite() {
        HwUtil.redirectWithHistory(this.sessionStorageService.getReturnUrl());
    }


    // spinner helper functions --------------
    showSpinner() {
        this.progressVisible = true;
    }

    // observablen�l ez a finally
    hideSpinnerWithSubscription(subscription: Subscription) {
        subscription.add(() => {
            this.requestFinished();
            this.hideSpinnerInternal();
        });
    }

    hideSpinner() {
        this.requestFinished();
        this.hideSpinnerInternal();
    }

    hideSpinnerInternal() {
        this.progressVisible = false;
    }

    private apiRequestFinished: boolean;
    private apiRequestDelay: number = 500;
    requestFinished() {
        this.apiRequestFinished = true;
    }

    showSpinnerWithDelay() {
        this.apiRequestFinished = false;

        setTimeout(() => {
            if (!this.apiRequestFinished)
                this.showSpinner();
        }, this.apiRequestDelay);
    }
    // spinner helper functions --------------
}       